// Base
import { BaseApi } from 'api/base.api'

// Interface
import {
  IAuthApi,
  IAuthApiRequest,
  IAuthApiChangeRoleAttrs,
  IAuthApiChangeRoleResponse,
  IAuthApiGetAuthenticatedUserResponse,
} from 'interfaces/auth/auth-api.interface'

// Constant
import { ApiConstant } from 'constant'

// Utils
import { axios_renderUrl } from 'utils'

export class AuthApi extends BaseApi<IAuthApi> implements IAuthApiRequest {
  readonly url = ApiConstant.AUTH_URL
  private authUrl = axios_renderUrl(this.url, ApiConstant.BACK_OFFICE)

  /**
   * @description Get authenticated user
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @return {Promise<IAuthApiChangeRoleResponse>} Promise<IAuthApiChangeRoleResponse>
   */
  async auth_getAuthenticatedUser(): Promise<IAuthApiGetAuthenticatedUserResponse> {
    return this.POST(`${this.authUrl}/me`, {})
  }

  /**
   * @description Change active role
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {IAuthApiChangeRoleAttrs} payload
   *
   * @return {Promise<IAuthApiChangeRoleResponse>} Promise<IAuthApiChangeRoleResponse>
   */
  async auth_changeRole(payload: IAuthApiChangeRoleAttrs): Promise<IAuthApiChangeRoleResponse> {
    return this.POST(`${this.authUrl}/changeActiveRole`, payload.body, { ...payload.requestConfig })
  }
}
